const TZ = "America/Sao_Paulo";

function spWallClock() {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", second: "2-digit", hourCycle: "h23", weekday: "short",
  }).formatToParts(new Date());
  const p = {};
  for (const { type, value } of parts) p[type] = value;
  const hour = p.hour === "24" ? "00" : p.hour;
  return { wall: new Date(`${p.year}-${p.month}-${p.day}T${hour}:${p.minute}:${p.second}`), weekday: p.weekday };
}

// Promoção de domingo: ativa das 6h de domingo às 6h de segunda (horário de Brasília)
export function getSundayPromo() {
  const { wall, weekday } = spWallClock();
  const active = (weekday === "Sun" && wall.getHours() >= 6) || (weekday === "Mon" && wall.getHours() < 6);
  if (!active) return { active: false, remaining: "" };
  const end = new Date(wall);
  if (weekday === "Sun") end.setDate(end.getDate() + 1);
  end.setHours(6, 0, 0, 0);
  const ms = Math.max(0, end - wall);
  const pad = (n) => String(n).padStart(2, "0");
  return {
    active: true,
    hours: pad(Math.floor(ms / 3.6e6)),
    minutes: pad(Math.floor((ms % 3.6e6) / 6e4)),
    seconds: pad(Math.floor((ms % 6e4) / 1e3)),
  };
}
